import PackageResultCard from '../components/results/PackageResultCard';
import SearchResultsLayout from '../components/SearchResultsLayout';
import { SEARCH_BANNERS } from '../data/mockData';

export default function PackageResultsPage() {
  return (
    <SearchResultsLayout
      type="packages"
      bannerImage={SEARCH_BANNERS.packages}
      title="Vacation Package Results"
      summary={(sp) =>
        `${sp.get('destination') || 'Destination'} · ${sp.get('depart') || '—'} – ${sp.get('return') || '—'}`
      }
      renderCard={(item, searchParams) => (
        <PackageResultCard key={item.id} item={item} searchParams={searchParams} />
      )}
    />
  );
}
